// import { useState, createContext, useContext } from 'react'

// const ModalContext = createContext()

// export const ModalProvider = ({ children }) => {
//   const [modal, setModal] = useState({
//     status: false,
//     children: null,
//   })

//   function onClose() {
//     setModal({
//       status: false,
//       children: null,
//     })
//   }
//   function openModal(children) {
//     setModal({
//       status: true,
//       children: children,
//     })
//   }
//   return (
//     <ModalContext.Provider value={{ modal, openModal, onClose }}>
//       {children}
//       <ModalContent onClose={onClose} status={modal.status}>
//         {modal.children}
//       </ModalContent>
//     </ModalContext.Provider>
//   )
// }

// const ModalContent = (props) => {
//   const { children, status, onClose } = props
//   return (
//     <>
//       {status && (
//         <div
//           className="absolute top-0 left-0 h-screen w-screen"
//           onClick={onClose}
//         ></div>
//       )}
//       <div
//         className={`z-40 h-screen bg-slate-200 fixed 
//         ${
//           status
//             ? 'top-0 right-0 duration-500 left-0 lg:left-[50%] 2xl:left-[60%]'
//             : '-right-[100%] bottom-0 duration-500 left-full'
//         }`}
//       >
//         <div className="h-full px-6 py-4 overflow-auto">
//           <button className="font-bold text-4xl ml-[95%]" onClick={onClose}>
//             <i className="fas fa-times"></i>
//           </button>
//           {status ? children : null}
//         </div>
//       </div>
//     </>
//   )
// }

// export default ModalContent

// export const useModal = () => useContext(ModalContext)

// import { useState, createContext, useContext, useEffect } from 'react'
// import { usePriority } from './PriorityContext'

// const ModalContext = createContext()

// export const ModalProvider = ({ children }) => {
//   const [modal, setModal] = useState({
//     status: false,
//     children: null,
//   })

//   const { priority, setPriority } = usePriority()

//   function onClose() {
//     setModal({
//       status: false,
//       children: null,
//     })
//     setPriority(0)

//     window.dispatchEvent(new Event('modal-close'))
//   }
//   function openModal(children) {
//     setModal({
//       status: true,
//       children: children,
//     })
//     setPriority(0)
//   }

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === 'Escape' && modal.status && priority === 0) {
//         onClose()
//       }
//     }

//     if (modal.status) {
//       document.addEventListener('keydown', handleKeyDown)
//     }

//     return () => {
//       document.removeEventListener('keydown', handleKeyDown)
//     }
//   }, [modal.status, priority]) 



//   return (
//     <ModalContext.Provider value={{ modal, openModal, onClose }}>
//       {children}
//       <ModalContent onClose={onClose} status={modal.status}>
//         {modal.children}
//       </ModalContent>
//     </ModalContext.Provider>
//   )
// }

// const ModalContent = (props) => {
//   const { children, status, onClose } = props
//   return (
//     <>
//       {status && (
//         <div
//           className="absolute top-0 left-0 h-screen w-screen"
//           onClick={onClose}
//         ></div>
//       )}
//       <div
//         className={`z-40 h-screen bg-slate-200 fixed 
//         ${
//           status
//             ? 'top-0 right-0 duration-500 left-0 lg:left-[50%] 2xl:left-[60%]'
//             : '-right-[100%] bottom-0 duration-500 left-full'
//         }`}
//       >
//         <div className="h-full px-6 py-4 overflow-auto">
//           <button className="font-bold text-4xl ml-[95%]" onClick={onClose}>
//             <i className="fas fa-times"></i>
//           </button>
//           {status ? children : null}
//         </div>
//       </div>
//     </>
//   )
// }

// export default ModalContent

// export const useModal = () => useContext(ModalContext)

import { useState, createContext, useContext, useEffect } from "react";
import { usePriority } from "./PriorityContext";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState([]);
  const { priority, setPriority } = usePriority();

  function openModal(children) {
    setModals((prev) => [...prev, { children }]);
    setPriority(0);
  }

  function onClose() {
    setModals((prev) => prev.slice(0, -1));
    setPriority(0);

    window.dispatchEvent(new Event("modal-close"));
  }

  function closeAll() {
    setModals([]);
    setPriority(0);
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && modals.length > 0 && priority === 0) {
        onClose();
      }
    };

    if (modals.length > 0) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modals, priority]);

  return (
    <ModalContext.Provider value={{ openModal, onClose, closeAll }}>
      {children}

      {modals.map((modal, index) => (
        <ModalContent
          key={index}
          onClose={onClose}
          zIndex={1 + index}
        >
          {modal.children}
        </ModalContent>
      ))}
    </ModalContext.Provider>
  );
};

const ModalContent = ({ children, onClose, zIndex }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 10);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <div
        style={{ zIndex }}
        className={`fixed top-0 left-0 h-screen w-screen bg-black/5 transition-opacity duration-300 ${show ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
      />

      <div
        style={{ zIndex: zIndex + 1 }}
        className={`fixed h-screen bg-slate-200 transition-all duration-500
        ${show
            ? "top-0 right-0 left-0 lg:left-[50%] 2xl:left-[60%]"
            : "top-0 -right-[100%] left-full"
          }`}
      >
        <div className="h-full px-6 py-4 overflow-auto">
          <button
            className="font-bold text-4xl ml-[95%]"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>

          {children}
        </div>
      </div>
    </>
  );
};

export const useModal = () => useContext(ModalContext);